import React, { useState, useEffect } from "react";
import { string, func, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { Bookmark, BookmarkActive } from "../../atoms/icons/StoryPageIcons";

import { createBookmark, deleteBookmarkByPageId, emailLink } from "../../helper/api";
import { setBookmark } from "../../helper/actions";
import PopupOverlay from "../../molecules/PopupOverlay";
import { googleTagEvents } from "../../utils/utils";

import "./bookmarkViewIcon.m.css";

const BookmarkViewIcon = ({
  story,
  bookmark,
  setBookmark,
  metypeConfig,
  color1,
  color2,
  jwtToken,
  navigateToPage,
  member,
  publisherAttributes,
  clickFrom,
}) => {
  const [isBookmarkClicked, setIsBookmarkClicked] = useState(false);
  const [loginPopup, setLoginPopup] = useState(false);
  const [verifyPopup, setVerifyPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  useEffect(() => {
    if (isBookmarkClicked) {
      // call bookmark func
      setBookmark({});
      callBookmarkApi();
    }
  }, [isBookmarkClicked]);

  const onBookmarkClick = () => {
    googleTagEvents("social-share", `Bookmark ${clickFrom || ""}`, "");
    if (jwtToken && !isBookmarkClicked) {
      setIsBookmarkClicked(true);
    }

    if (!jwtToken) {
      if (member && !member["verification-status"]) {
        setPopupMessage(
          `Please check for an activation link at ${member.email}. Verify your email to save the article.`
        );
        setVerifyPopup(true);
      } else {
        setPopupMessage("Please login to save the article");
        setLoginPopup(true);
      }
    }
  };

  const verifyEmailAccount = () => {
    emailLink(member.email, `${story.url}`).then(() => {
      setVerifyPopup(false);
    });
  };

  const callBookmarkApi = () => {
    const storyObj = {
      alternative: story.alternative || {},
      authors: story.authors || [],
      tags: story.tags || [],
      headline: story.headline,
      "hero-image-metadata": story["hero-image-metadata"],
      "hero-image-s3-key": story["hero-image-s3-key"],
      "last-published-at": story["last-published-at"],
      "published-at": story["published-at"],
      metadata: story.metadata || {},
      slug: story.slug,
      id: story.id,
      url: story.url,
      "story-template": story["story-template"],
      subheadline: story.subheadline || "",
    };

    if (story["author-id"]) {
      storyObj["author-id"] = story["author-id"];
    }
    if (story["author-name"]) {
      storyObj["author-name"] = story["author-name"];
    }

    const requestObj = {
      data: {
        type: "bookmark",
        attributes: [
          {
            metadata: storyObj,
            page_id: window.btoa(unescape(encodeURI(encodeURI(story.url)))),
            read_at: new Date().toISOString().split("T")[0], // In yyyy-mm-dd format
          },
        ],
      },
    };

    createBookmark(metypeConfig, requestObj, jwtToken)
      .then((data) => setBookmark(data))
      .catch((err) => {
        console.log(err);
        setBookmark(null);
      })
      .finally(() => {
        setIsBookmarkClicked(false);
      });
  };

  const onRemoveBookmarkClick = () => {
    googleTagEvents("social-share", `Bookmark ${clickFrom || ""}`, "");
    deleteBookmarkByPageId(metypeConfig, story.url, jwtToken)
      .then(() => setBookmark(null))
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div styleName="bookmark-view-icon" onClick={bookmark ? onRemoveBookmarkClick : onBookmarkClick}>
      {bookmark ? <BookmarkActive /> : <Bookmark color1={color1} color2={color2} />}
      {(loginPopup || verifyPopup) && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={popupMessage}
          onClickHandler={verifyEmailAccount}
          buttonType={verifyPopup ? "" : "login"}
        />
      )}
    </div>
  );
};

BookmarkViewIcon.propTypes = {
  setBookmark: func,
  color1: string,
  color2: string,
  story: object,
  bookmark: object,
  jwtToken: string,
  metypeConfig: object,
  navigateToPage: func,
  member: object,
  publisherAttributes: object,
  clickFrom: string,
};

const mapStateToProps = (state) => ({
  bookmark: get(state, ["userReducer", "bookmark"], null),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  member: state.member || null,
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setBookmark: (bookmarkObj) => dispatch(setBookmark(bookmarkObj)),
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkViewIcon);
